import Component from '@glimmer/component';
import { action } from '@ember/object';

/**
 * @param {Function}            onDestroy
 * @param {Function}            selectedDidChange
 * @param {Array}               selectedItems
 * @param {Array}               items
 */
export default class MultiCheckbox extends Component {
  lastClickedIndex = null;
  lastClickedItem = null;

  // this should be called when list of items change
  // for example, when list of items is being removed by the parent component
  @action
  itemsDidChange() {
    const lastClickedIndexCache = this.lastClickedIndex;
    const lastClickedItemCache = this.lastClickedItem;
    const items = this.args.items;
    const lastClickedItem = items.objectAt(lastClickedIndexCache);

    // If the position of the last click changed we should clear the last click cache
    if (lastClickedIndexCache && lastClickedItemCache && lastClickedItemCache !== lastClickedItem) {
      this.lastClickedIndex = null;
      this.lastClickedItem = null;
    }

    const selectedItems = this.args.selectedItems;
    const toRemove = [];
    selectedItems.forEach((item) => {
      if (!items.includes(item)) {
        toRemove.push(item);
      }
    });
    selectedItems.removeObjects(toRemove);
  }

  toggleSingle(item) {
    if (!this.args.selectedItems.includes(item)) {
      this.args.selectedItems.pushObject(item);
    } else {
      this.args.selectedItems.removeObject(item);
    }
  }

  @action
  toggleChecked(item, event) {
    // this component support toggle single item or multiple item
    const lastClickedIndex = this.lastClickedIndex;
    const lastClickedItem = this.lastClickedItem;
    const selectedItems = this.args.selectedItems;
    const items = this.args.items;

    // toggle single item
    if (!event.shiftKey || lastClickedIndex === null) {
      this.toggleSingle(item);
    } else {
      // toggle multiple item when user has an item is being clicked earlier
      // and user press shift key.
      const targetIndex = items.indexOf(item);

      // calculate the range of targeted items
      const targetIndexStart = Math.min(targetIndex, lastClickedIndex);
      // we only have to +1 the targetIndex because the lastClickedIndex is already in the correct state
      const targetIndexEnd = Math.max(targetIndex + 1, lastClickedIndex);
      const targetItems = items.slice(targetIndexStart, targetIndexEnd);

      if (!selectedItems.includes(item) && selectedItems.includes(lastClickedItem)) {
        // add targetItems into list of selected items
        this.args.selectedItems.addObjects(targetItems);
      } else if (selectedItems.includes(item) && !selectedItems.includes(lastClickedItem)) {
        // remove targetItems from list of selected items
        this.args.selectedItems.removeObjects(targetItems);
      } else {
        // otherwise, treat this as toggle single item
        this.toggleSingle(item);
      }
    }

    // update last click cache
    this.lastClickedIndex = items.indexOf(item);
    this.lastClickedItem = item;
    this.args.selectedDidChange(this.args.selectedItems);
  }

  willDestroy() {
    super.willDestroy(...arguments);
    if (this.args.onDestroy) {
      this.args.onDestroy();
    }
  }
}
